import { Input as AntdInput, Form } from 'antd'
import Button from 'components/Button/index'
import CalendarPicker from 'components/CalendarPicker'
import { DateRangePicker } from 'components/DatePickerStyled/DateRangePicker/index'
import FilterDiv from 'components/FilterDiv'
import Flex from 'components/Flex'
import Inputs from 'components/Form/Input'
import {
  default as Radio,
  default as RadioButton,
} from 'components/Form/RadioButton'
import TextAreas from 'components/Form/TextArea'
import RangeSlider from 'components/RangeSlider/index'
import Select from 'components/Select/index'
import SelectDropDown from 'components/SelectWithCheckBox'
import { RadioGroup } from 'components/UIComponents/FormStyles'
import Clock from 'components/icons/Clock'
import DeleteIcon from 'components/icons/DeleteIcon'
import LinkIcon from 'components/icons/LinkIcon'
import PlusWhiteIcon from 'components/icons/PlusBlueIcon'
import PencilIconImage from 'components/icons/pencilImage.png'
import { format, parse } from 'date-fns'
import {
  MenuFlex,
  SubmitFlex,
} from 'modules/Drives/Components/DriveTable/Drivefilter/Style/style'
import CandidateDetails from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/Components/CandidateDetails'
import SelectMode from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/Components/SelectMode/index'
import {
  ChangeDiv,
  Commondiv,
  Diveder,
  FormItem,
  IconWrapper,
  ModeFlex,
  NoneContainer,
  NoneWrapper,
  SessionFlex,
  StartSpan,
  StyledTag,
  TextWrapper,
  TimeInfoSpan,
  TotalTimeDiv,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/style'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import {
  EmptyElement,
  EmptySpan,
} from '../../../../../components/UIComponents/CommonStyledDiv'
import ClosedCircleIcon from '../../../../../components/icons/ClosedCircleIcon'
import {
  assessmentOptions,
  optionTime,
  RadioOptions,
} from '../../../../../utils/commonFunction'

const { TextArea } = AntdInput

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
`
const AntdInputStyle = styled(AntdInput)`
  ::placeholder {
    font-size: 16px;
  }
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_BASE};
  color: ${COLORS.GREY_T_40};
  width: ${props => (props.width ? props.width : 'auto')};
  height: ${props => (props.height ? props.height : '48px')};
  padding: ${props => (props.padding ? props.padding : '')};
  border-radius: 8px;
  box-shadow: none;
  border-color: ${props => (props.error ? 'red' : '#e9e9e9')};
  :focus {
    border-color: #e9e9e9;
    box-shadow: none;
  }
  :hover {
    border-color: #e9e9e9;
  }
  :not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #e9e9e9 !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: none;
    border-right-width: 0px !important;

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`

const dropdownRender = (
  menu,
  interviewType,
  linkPanelData,
  name,
  onClickNone
) => {
  return (
    <>
      {interviewType === 'ASSESMENT' && (
        <Fragment>
          <NoneContainer onClick={onClickNone}>
            <Flex column>
              <TextWrapper>Available</TextWrapper>
              <Flex row spaceBetween>
                <NoneWrapper centerVertically>None</NoneWrapper>
                <RadioGroup
                  value={
                    linkPanelData[name]?.panel[0]?.id === null
                      ? 'None'
                      : linkPanelData[name]?.panel.map(({ id }) => id)
                  }
                >
                  <RadioButton value={'None'} />
                </RadioGroup>
              </Flex>
            </Flex>
          </NoneContainer>
          <Diveder />
        </Fragment>
      )}
      {menu}
    </>
  )
}

const ScheduleInterviewForm = ({
  form,
  selectedCandidate,
  rolesMetrics,
  setChangeLocationDrawer,
  driveData,
  candidateDeatils,
  SelectedRoundName,
  interviewMode,
  linkPanelData,
  isSingleOrBulk,
  interviewType,
  candidates,
  setCandidates,
  handleIterviewRound,
  disabledDate,
  onDurationChange,
  onChangeMode,
  onChangeLink,
  onSelectInterview,
  onSubmitFormData,
  selectedRoundType,
  setLinkPanelData,
  onChangeTimeRange,
  timeRanges,
  interviewList,
  getUpdatedList,
  isBulk,
  checked,
  locations,
  setOpen,
  open,
  dateArr,
  setDateArr,
  singleLocationChange,
  onMultiChangeDates,
  parametersList,
  setParametersList,
}) => {
  let linkPanelInitialValue = {
    link: '',
    panel: [
      {
        id: null,
        firstName: null,
        lastName: null,
      },
    ],
  }
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [inputText, setInputText] = useState('')

  useEffect(() => {
    form.setFieldsValue({
      linkAndPanel: [linkPanelInitialValue],
    })
  }, [])

  useEffect(() => {
    getUpdatedList()
  }, [linkPanelData])

  const addToForm = () => {
    getUpdatedList()
    const shouldAddNewPanelData =
      interviewMode === 'OFFLINE' ||
      (interviewMode === 'EXTERNAL_LINK' && interviewType === 'ASSESMENT') ||
      interviewType === 'EXTERNAL_ASSESMENT'
    if (shouldAddNewPanelData) {
      setLinkPanelData([
        ...linkPanelData,
        {
          panel: [
            {
              id: null,
              firstName: null,
              lastName: null,
            },
          ],
        },
      ])
    } else {
      setLinkPanelData([...linkPanelData, linkPanelInitialValue])
    }
  }

  const onRemove = name => {
    setLinkPanelData(linkPanelData?.filter((data, index) => index !== name))
  }

  const copyLinkText = link => {
    if (link) {
      navigator.clipboard.writeText(link)
      SuccessMessage('Link Copied!!')
    }
  }

  const handleLocation = () => {
    setChangeLocationDrawer(true)
  }

  const onClickNone = () => {}

  const branchName = locations.map(location => location.branchName)
  const cities = locations.map(location => location.city)
  const states = locations.map(location => location.state)
  const countries = locations.map(location => location.country)

  const locationData = {
    branchName: branchName[0],
    cities: cities[0],
    states: states[0],
    countries: countries[0],
  }
  const locationChangeData = {
    branchName: singleLocationChange?.branchName,
    cities: singleLocationChange?.city,
    states: singleLocationChange?.state,
    countries: singleLocationChange?.country,
  }

  const locationValue = `${
    locationData?.branchName ? locationData?.branchName : ''
  } ${locationData?.cities ? locationData?.cities : ''}, ${
    locationData?.states ? locationData?.states : ''
  }, ${locationData?.countries ? locationData?.countries : ''}`
  const locationValueChange = `${locationChangeData?.branchName} ${locationChangeData?.cities}, ${locationChangeData?.states}, ${locationChangeData?.countries}`

  const formatDate = dateString => {
    const date = parse(dateString, 'yyyy-MM-dd', new Date())
    const formattedDate = format(date, 'd MMM, yyyy - EEE')
    return formattedDate
  }

  const handleDateRemove = indexToRemove => {
    const updatedDateArr = dateArr?.filter(
      (date, index) => index !== indexToRemove
    )
    setDateArr(updatedDateArr)
    onMultiChangeDates(updatedDateArr)
  }

  const compareDates = (date1, date2) => {
    return new Date(date1) - new Date(date2)
  }
  const [date, setDate] = useState([])

  const onsubmitDate = () => {
    setDateArr(date)
  }
  const pickerChangeHandler = dates => {
    let datesString = dates.map(date =>
      moment(date?.unix * 1000).format('YYYY-MM-DD')
    )
    setDate(datesString)

    datesString.sort(compareDates)
    setDateArr(datesString)
    onMultiChangeDates(datesString)
  }
  const handleInputChange = e => {
    setInputText(e.target.value)
  }
  const addParameter = () => {
    if (
      inputText?.trim() !== '' &&
      inputText &&
      parametersList.indexOf(inputText?.toUpperCase()) === -1
    ) {
      setParametersList([...parametersList, inputText?.trim()?.toUpperCase()])
      setInputText('')
    } else {
      ErrorMessage('Evaluation parameter is already exists. ')
      setInputText('')
    }
  }
  const handleClose = removedTag => {
    const newTags = parametersList.filter(tag => tag !== removedTag)
    setParametersList(newTags)
  }
  const handleEdit = removedTag => {
    setInputText(removedTag)
    const newTags = parametersList.filter(tag => tag !== removedTag)
    setParametersList(newTags)
  }
  const menu = (
    <div style={{ width: '16rem' }}>
      <MenuFlex column>
        <div
          style={{ marginTop: '2rem', marginLeft: '1rem', marginRight: '0rem' }}
        >
          <CalendarPicker
            multiple={true}
            numberOfMonths={1}
            minDate={new Date()}
            required={true}
            onCalenderChange={pickerChangeHandler}
          />
        </div>

        <SubmitFlex right>
          <Button.Secondary
            text="Cancel"
            onClick={() => {
              setOpen(false)
              setDate('')
              setDateArr([])
            }}
          />
          <Button.Primary
            text="Confirm"
            disabled={!dateArr}
            onClick={() => {
              setOpen(false)
              onsubmitDate()
            }}
          />
        </SubmitFlex>
      </MenuFlex>
    </div>
  )

  return (
    <Form
      scrollToFirstError
      onFinish={onSubmitFormData}
      id={'scheduleForm'}
      form={form}
      layout="vertical"
      initialValues={{
        linkAndPanel: [linkPanelInitialValue],
      }}
    >
      {isSingleOrBulk && (
        <CandidateDetails
          selectedCandidate={selectedCandidate}
          count={selectedCandidate?.length}
          isBulk={isBulk}
        />
      )}

      <FormItem
        name={'interviewRound'}
        rules={[{ required: true, message: 'Please select round name!' }]}
      >
        <TotalTimeDiv>
          Round Name<StartSpan>*</StartSpan>
        </TotalTimeDiv>
        <Select
          OptionData={rolesMetrics[0]?.rounds}
          nameParam="roundName"
          valueParam="roundName"
          placeholder="Round Name"
          onChange={handleIterviewRound}
          value={SelectedRoundName}
          disabled={true}
        />
      </FormItem>
      <FormItem
        name={'interviewType'}
        rules={[
          {
            required: false,
            message: 'Please select Interview type!',
          },
        ]}
      >
        <TotalTimeDiv>
          Interview Type <StartSpan>*</StartSpan>
        </TotalTimeDiv>
        <RadioGroup spaceBetween value={selectedRoundType?.type}>
          {RadioOptions?.map((item, index) => {
            return (
              <Radio
                key={index + item?.value}
                border={true}
                label={item?.label}
                value={item?.value}
                width={'100%'}
                disable={true}
              />
            )
          })}
        </RadioGroup>
      </FormItem>
      {interviewType === 'ASSESMENT' && (
        <FormItem>
          <TotalTimeDiv>
            Assesment Type <StartSpan>*</StartSpan>
          </TotalTimeDiv>
          <RadioGroup spaceBetween value={selectedRoundType?.assesmentType}>
            {assessmentOptions?.map((item, index) => (
              <Radio
                key={index + item?.value}
                border={true}
                label={item?.label}
                value={item?.value}
                width={'100%'}
                disable={true}
              />
            ))}
          </RadioGroup>
        </FormItem>
      )}
      {interviewType == 'GROUP' && (
        <FormItem
          marginbottom={'0px'}
          name={'candidatesPerGroup'}
          rules={[
            {
              required: true,
              message: 'Please select no. of candidates per group!',
            },
          ]}
        >
          <Commondiv padding={'4px'}>
            <TotalTimeDiv>Select no. of candidates per group</TotalTimeDiv>
            <RangeSlider
              inputValue={candidates}
              setInputValue={setCandidates}
              min={0}
              max={candidateDeatils?.candidateList?.count}
              percentage={false}
              sliderrules={[
                {
                  required: true,
                  message: 'required',
                },
                {
                  validator: (_, value) => {
                    if (
                      value >= 0 &&
                      value <= candidateDeatils?.candidateList?.count
                    ) {
                      return Promise.resolve()
                    } else {
                      return Promise.reject(new Error('Not Valid'))
                    }
                  },
                },
              ]}
              inputDis
            />
          </Commondiv>
        </FormItem>
      )}
      <Flex>
        <FormItem
          name={'mode'}
          rules={[
            {
              required: true,
              message: 'Please select mode!',
            },
          ]}
        >
          <ModeFlex row centerVertically>
            <Flex column>
              <TotalTimeDiv>
                Mode<StartSpan>*</StartSpan>
              </TotalTimeDiv>
              <SelectMode
                onChange={onChangeMode}
                placeholder={'Add Mode'}
                disabled={interviewType === 'EXTERNAL_ASSESMENT'}
                value={interviewMode}
                interviewType={interviewType}
                getPopupContainer={() => document.getElementById('mode')}
              />
            </Flex>
          </ModeFlex>
        </FormItem>
      </Flex>
      <FormItem
        name={'dates'}
        rules={[
          {
            required: true,
            message: 'Please select date!',
          },
        ]}
      >
        <TotalTimeDiv>
          Date <StartSpan>*</StartSpan>
        </TotalTimeDiv>
        <FilterDiv
          calendar={true}
          overlayMenu={menu}
          open={open}
          required
          placeholder={'Select the Date'}
          setOpen={setOpen}
          width={'100%'}
          dateValue={
            dateArr?.length > 1
              ? dateArr.length + ' Days Selected'
              : dateArr?.length == 1
              ? dateArr.length + ' Day Selected'
              : ''
          }
          onOpenChange={() => setIsMenuOpen(!isMenuOpen)}
        />
        <div>
          {dateArr?.length > 0 && (
            <TotalTimeDiv style={{ marginTop: '1.5rem' }}>
              Selected Dates <StartSpan>*</StartSpan>
            </TotalTimeDiv>
          )}
          <GridContainer>
            {dateArr?.map((date, index) => (
              <div key={index + 'dateArr'}>
                <AntdInputStyle
                  width={'100%'}
                  value={formatDate(date)}
                  suffix={
                    <EmptySpan
                      style={{ paddingTop: '10px' }}
                      onClick={() => handleDateRemove(index)}
                    >
                      <ClosedCircleIcon />
                    </EmptySpan>
                  }
                />
              </div>
            ))}
          </GridContainer>
        </div>
      </FormItem>
      <FormItem ismargin>
        <SessionFlex row centerVertically>
          <div>
            <FormItem
              name={'duration'}
              rules={[
                {
                  required: true,
                  message: 'Please select duration!',
                },
              ]}
            >
              <TotalTimeDiv>
                Duration <StartSpan>*</StartSpan>
              </TotalTimeDiv>
              <Select
                width="182px"
                OptionData={optionTime}
                nameParam="label"
                valueParam="value"
                placeholder="Duration"
                onChange={onDurationChange}
                id={'duration'}
                showSearch
              />
            </FormItem>
          </div>
          <FormItem
            name={'timeRange'}
            rules={[
              {
                required: true,
                message: 'Please select Time Range!',
              },
            ]}
          >
            <TotalTimeDiv>
              Time Range <StartSpan>*</StartSpan>
            </TotalTimeDiv>
            <DateRangePicker
              width="100%"
              suffixIcon={<Clock />}
              format={'HH:mm'}
              placeholder={['StartTime', 'EndTime']}
              picker={'time'}
              onChange={onChangeTimeRange}
              defaultValue={timeRanges}
            />
          </FormItem>
        </SessionFlex>
      </FormItem>
      {interviewType !== 'ASSESMENT' &&
        interviewType !== 'EXTERNAL_ASSESMENT' && (
          <>
            <FormItem
              ismargin={true}
              name={'parameters'}
              rules={[
                {
                  validator: (_, value) => {
                    if (parametersList?.length === 0) {
                      return Promise.reject(
                        new Error('Please Enter Evaluation Parameters')
                      )
                    } else {
                      return Promise.resolve()
                    }
                  },
                },
              ]}
            >
              <TotalTimeDiv>
                Evaluation Parameters <StartSpan>*</StartSpan>
              </TotalTimeDiv>
              <Inputs
                width="100%"
                placeholder={'Please Enter Evaluation Parameters'}
                value={inputText}
                onChange={handleInputChange}
              />
            </FormItem>
            <br></br>
            <Flex wrap>
              {parametersList?.map((item, index) => (
                <Flex
                  style={{ paddingRight: '10px' }}
                  key={index + 'parameterList'}
                >
                  <StyledTag key={item}>{item?.toLowerCase()}</StyledTag>
                  <EmptyElement
                    style={{ paddingTop: '8px' }}
                    onClick={() => handleEdit(item)}
                  >
                    {' '}
                    <img src={PencilIconImage} alt="editIcon" />
                  </EmptyElement>
                  <EmptyElement
                    style={{ paddingTop: '8px' }}
                    onClick={() => handleClose(item)}
                  >
                    {' '}
                    <DeleteIcon />
                  </EmptyElement>
                </Flex>
              ))}
            </Flex>

            <Button.Secondary
              text={'Add'}
              width="100%"
              icon={<PlusWhiteIcon />}
              dashed="true"
              onClick={() => {
                addParameter()
              }}
            />
            <br></br>
          </>
        )}
      {interviewMode === 'OFFLINE' && (
        <div>
          {checked === singleLocationChange.id ? (
            <Form.Item
              name={'location'}
              initialValue={locationValueChange}
              rules={[
                {
                  required: true,
                  message: 'Please enter the location!',
                },
              ]}
            >
              <Flex spaceBetween>
                <TotalTimeDiv>
                  Interview Location <StartSpan>*</StartSpan>
                </TotalTimeDiv>
                <ChangeDiv onClick={handleLocation}>Change</ChangeDiv>
              </Flex>
              <TextArea
                marginbottom={'0px'}
                placeholder={'Add Location'}
                type="text"
                value={locationValueChange}
              />
            </Form.Item>
          ) : (
            <Form.Item
              name={'location'}
              initialValue={locationValue}
              rules={[
                {
                  required: true,
                  message: 'Please enter the location!',
                },
              ]}
            >
              <Flex spaceBetween>
                <TotalTimeDiv>
                  Interview Location <StartSpan>*</StartSpan>
                </TotalTimeDiv>
                <ChangeDiv onClick={handleLocation}>Change</ChangeDiv>
              </Flex>
              <TextArea
                marginbottom={'0px'}
                placeholder={'Add Location'}
                type="text"
                value={locationValue}
              />
            </Form.Item>
          )}
        </div>
      )}

      {interviewMode !== 'OFFLINE' && (
        <Form.List name="linkAndPanel">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name }) => (
                  <SessionFlex spaceBetween centerVertically key={key + name}>
                    <FormItem>
                      <TotalTimeDiv>
                        Link <StartSpan>*</StartSpan>{' '}
                      </TotalTimeDiv>
                      <Inputs
                        width="100%"
                        suffix={
                          <IconWrapper
                            noBottom
                            onClick={() =>
                              copyLinkText(linkPanelData[name]?.link)
                            }
                          >
                            <LinkIcon />
                          </IconWrapper>
                        }
                        placeholder="Add Link"
                        onChange={e => onChangeLink(e, name)}
                        name={[name, 'link']}
                        type="url"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid link!',
                          },
                        ]}
                      />
                    </FormItem>
                    {interviewType !== 'ASSESMENT' &&
                      interviewType !== 'EXTERNAL_ASSESMENT' && (
                        <FormItem
                          name={[name, 'panel']}
                          rules={[
                            {
                              required: true,
                              message: 'Please select interviewer!',
                            },
                          ]}
                        >
                          <TotalTimeDiv>
                            Interviewer/Panel {name + 1}
                          </TotalTimeDiv>
                          <div id={name + 1}>
                            <SelectDropDown
                              width="100%"
                              optionDivData={interviewList}
                              maxTagCount={1}
                              isInterviewer={true}
                              valueParam="_id"
                              nameParam="first_name"
                              lastNameParam="last_name"
                              optionLabelProp={'label'}
                              placement={'bottomLeft'}
                              placeholder={'Select Interviewers'}
                              dropdownMatchSelectWidth={false}
                              dropdownStyle={{ width: '20%' }}
                              value={
                                linkPanelData[name]?.panel[0]?.id === null
                                  ? []
                                  : linkPanelData[name]?.panel.map(
                                      ({ id }) => id
                                    )
                              }
                              onChange={(value, option) =>
                                onSelectInterview(value, option, name)
                              }
                              getPopupContainer={() =>
                                document.getElementById(name + 1)
                              }
                            />
                          </div>
                        </FormItem>
                      )}

                    {isSingleOrBulk &&
                      (interviewType !== 'ASSESMENT' ||
                        interviewType !== 'EXTERNAL_ASSESMENT') && (
                        <IconWrapper
                          center
                          onClick={() => {
                            remove(name)
                            onRemove(name)
                          }}
                          disable={linkPanelData?.length === 1}
                        >
                          <DeleteIcon />
                        </IconWrapper>
                      )}
                  </SessionFlex>
                ))}
                {isSingleOrBulk &&
                  (interviewType !== 'ASSESMENT' ||
                    interviewType !== 'EXTERNAL_ASSESMENT') && (
                    <Form.Item>
                      <Button.Secondary
                        text={'Add'}
                        width="100%"
                        icon={<PlusWhiteIcon />}
                        dashed="true"
                        onClick={() => {
                          addToForm()
                          add()
                        }}
                      />
                    </Form.Item>
                  )}
              </>
            )
          }}
        </Form.List>
      )}
      {interviewMode === 'OFFLINE' && (
        <Form.List name="linkAndPanel">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name }) => (
                  <SessionFlex spaceBetween centerVertically key={key + name}>
                    <FormItem
                      name={[name, 'panel']}
                      rules={[
                        {
                          required: true,
                          message: 'Please select interviewer!',
                        },
                      ]}
                    >
                      <TotalTimeDiv>Interviewer/Panel {name + 1}</TotalTimeDiv>
                      <div id={name + 1}>
                        <SelectDropDown
                          width="100%"
                          optionDivData={interviewList}
                          maxTagCount={1}
                          isInterviewer={true}
                          valueParam="_id"
                          nameParam="first_name"
                          lastNameParam="last_name"
                          optionLabelProp={'label'}
                          placement={'bottomLeft'}
                          placeholder={'Select Interviewers'}
                          dropdownMatchSelectWidth={false}
                          dropdownStyle={{ width: '20%' }}
                          mode={
                            interviewType === 'ASSESMENT' &&
                            linkPanelData[name]?.panel[0]?.id === null
                              ? ''
                              : 'multiple'
                          }
                          onChange={(value, option) =>
                            onSelectInterview(value, option, name)
                          }
                          value={
                            interviewType === 'ASSESMENT' &&
                            linkPanelData[name]?.panel[0]?.id === null
                              ? 'None'
                              : linkPanelData[name]?.panel[0]?.id === null
                              ? []
                              : linkPanelData[name]?.panel.map(({ id }) => id)
                          }
                          getPopupContainer={() =>
                            document.getElementById(name + 1)
                          }
                          dropdownRender={menu =>
                            dropdownRender(
                              menu,
                              interviewType,
                              linkPanelData,
                              name,
                              onClickNone
                            )
                          }
                        />
                      </div>
                    </FormItem>

                    {isSingleOrBulk && interviewType !== 'ASSESMENT' && (
                      <IconWrapper
                        center
                        onClick={() => {
                          remove(name)
                          onRemove(name)
                        }}
                        disable={linkPanelData?.length === 1}
                      >
                        <DeleteIcon />
                      </IconWrapper>
                    )}
                  </SessionFlex>
                ))}
                {isSingleOrBulk && interviewType !== 'ASSESMENT' && (
                  <Form.Item>
                    <Button.Secondary
                      text={'Add'}
                      width="100%"
                      icon={<PlusWhiteIcon />}
                      dashed="true"
                      onClick={() => {
                        add()
                        addToForm()
                      }}
                    />
                  </Form.Item>
                )}
              </>
            )
          }}
        </Form.List>
      )}

      <FormItem>
        <Flex spaceBetween>
          <TotalTimeDiv>Note/Instructions</TotalTimeDiv>
          <TimeInfoSpan>Visible to the candidate</TimeInfoSpan>
        </Flex>
        <TextAreas
          marginbottom={'0px'}
          name={'instructions'}
          placeholder={'Add Note for the Candidates'}
          required
        />
      </FormItem>
    </Form>
  )
}

export default ScheduleInterviewForm
